import colors, { TypeColorNames } from "../../../theme/colors";

export function TrashIcon({ onClick, style, color }: { onClick?: any, style?: React.CSSProperties, color?: TypeColorNames}): JSX.Element {
  return (
    <svg
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      onClick={onClick}
    >
      <path
        d="M2.94512 10.1625L2.59117 3.0835H12.681L12.327 10.1625C12.2405 11.8921 10.8129 13.2502 9.08107 13.2502H6.19106C4.45922 13.2502 3.0316 11.8921 2.94512 10.1625Z"
        stroke={color ? colors[color] : colors.label}
        strokeWidth="1.5"
      />
      <path
        d="M7.63639 0.750244C6.49586 0.750244 5.56115 1.6315 5.47604 2.75024H9.79675C9.71164 1.6315 8.77693 0.750244 7.63639 0.750244Z"
        stroke={color ? colors[color] : colors.label}
        strokeWidth="1.5"
      />
      <path
        d="M1.21973 2.91699H14.0531"
        stroke={color ? colors[color] : colors.label}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M9.38623 6.41699V9.33366"
        stroke={color ? colors[color] : colors.label}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M5.88623 6.41699V9.33366"
        stroke={color ? colors[color] : colors.label}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
